import React, { type ReactElement, useCallback } from 'react'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import {
  cardAddProxy
} from '../../../../../shared/components/CardAddSlideOver/cardAddProxy'
import PlusIcon from '../../../../../shared/components/ui/icons/PlusIcon'
import AddEntityButton from '../../../../../shared/components/ui/buttons/AddEntityButton'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../shared/utils/gtmUtils'
import { populateCardInformationFromCustomer } from './utils'

export function AddCardButton (): ReactElement {
  const { siteTheme: { addEntityButton } } = useSnapshot(proxyGlobalAuth)

  const onAddClick = useCallback(() => {
    populateCardInformationFromCustomer()
    gtmTrackButtonPress(GtagEvents.CARD_MODAL_OPEN)

    cardAddProxy.displaySlideOverCAP = true
    //Ensure that the ACH section variable is set to false...BC
    cardAddProxy.displayACHSection = false
  }, [])

  return (
    <AddEntityButton clickFunction={onAddClick} icon={<PlusIcon color={addEntityButton.iconClasses} />} text="New Card" />
  )
}
